import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import { ButtonSave, ButtonWrapper } from '../StyledComponents';
var FormStyled = styled('form')(function(param) {
    var theme = param.theme;
    return {
        marginTop: theme.spacing(6)
    };
});
export var LoginForm = function(param) {
    var formRef = param.formRef, loginUrl = param.loginUrl, _param_login = param.login, login = _param_login === void 0 ? 'login' : _param_login, _param_keepMeSign = param.keepMeSign, keepMeSign = _param_keepMeSign === void 0 ? false : _param_keepMeSign, disabled = param.disabled, userName = param.userName, password = param.password, newPassword = param.newPassword, antiForgeryToken = param.antiForgeryToken, tenant = param.tenant, returnUrl = param.returnUrl, name = param.name, submitTitle = param.submitTitle, _param_isBtnTypeSubmit = param.isBtnTypeSubmit, isBtnTypeSubmit = _param_isBtnTypeSubmit === void 0 ? false : _param_isBtnTypeSubmit, onSubmit = param.onSubmit, passwordlessTitle = param.passwordlessTitle, isPasswordlessVisible = param.isPasswordlessVisible, onPasswordless = param.onPasswordless;
    var getTestId = useTestId().getTestId;
    return /*#__PURE__*/ _jsxs(FormStyled, {
        ref: formRef,
        autoComplete: "off",
        method: "post",
        action: loginUrl.toString(),
        children: [
            /*#__PURE__*/ _jsx("input", {
                readOnly: true,
                type: "hidden",
                name: "Username",
                value: userName
            }),
            /*#__PURE__*/ _jsx("input", {
                readOnly: true,
                type: "hidden",
                name: "Password",
                value: newPassword !== null && newPassword !== void 0 ? newPassword : password
            }),
            /*#__PURE__*/ _jsx("input", {
                readOnly: true,
                type: "hidden",
                name: "__RequestVerificationToken",
                value: antiForgeryToken
            }),
            /*#__PURE__*/ _jsx("input", {
                readOnly: true,
                type: "hidden",
                name: "button",
                value: login
            }),
            /*#__PURE__*/ _jsx("input", {
                readOnly: true,
                type: "hidden",
                name: "tenant",
                value: tenant
            }),
            keepMeSign ? /*#__PURE__*/ _jsx("input", {
                readOnly: true,
                type: "hidden",
                name: "RememberLogin",
                value: "true"
            }) : null,
            /*#__PURE__*/ _jsx("input", {
                readOnly: true,
                type: "hidden",
                name: "ReturnUrl",
                value: returnUrl
            }),
            /*#__PURE__*/ _jsx(ButtonWrapper, {
                children: /*#__PURE__*/ _jsx(ButtonSave, {
                    fullWidth: true,
                    color: "primary",
                    disabled: disabled,
                    type: isBtnTypeSubmit ? 'submit' : 'button',
                    variant: "contained",
                    "data-testid": getTestId(name),
                    onClick: onSubmit,
                    children: submitTitle
                })
            }),
            isPasswordlessVisible && passwordlessTitle ? /*#__PURE__*/ _jsx(ButtonWrapper, {
                children: /*#__PURE__*/ _jsx(ButtonSave, {
                    fullWidth: true,
                    type: "button",
                    color: "primary",
                    variant: "outlined",
                    disabled: disabled,
                    onClick: onPasswordless,
                    children: passwordlessTitle
                })
            }) : null
        ]
    });
};
